import { BookingQuestion } from "../types/bookingQuestions";

// Function to check if a string is a UUID
const isUUID = (str: string): boolean => {
	const uuidRegex =
		/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
	return uuidRegex.test(str);
};

export const experiencesService = {
	async getExperiences(promoterId: string) {
		const apiUrl = `${
			process.env.REACT_APP_API_URL
		}/experiences?promoter=${promoterId}&page=1&size=${10}`;

		try {
			const response = await fetch(apiUrl, {
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (response.status === 404) {
				return [];
			}

			if (!response.ok) {
				const errorText = await response.text();
				console.error("Error response text:", errorText);
				throw new Error("Network response was not ok");
			}
			const contentType = response.headers.get("content-type");
			if (contentType && contentType.includes("application/json")) {
				return response.json();
			} else {
				const errorText = await response.text();
				console.error("Error: Expected JSON but received:", errorText);
				throw new Error("Received non-JSON response");
			}
		} catch (error) {
			console.error("Fetch error:", error);
			throw error;
		}
	},

	async getExperience(identifier: string) {
		// Determine if the identifier is a UUID or an alias
		// we must strip any query params before checking if it's uuid
		const cleanedIdentifier = identifier.split("?")[0];

		const endpoint = isUUID(cleanedIdentifier)
			? `/experiences/${identifier}`
			: `/experiences/alias/${identifier}`;

		const apiUrl = `${process.env.REACT_APP_API_URL}${endpoint}`;

		try {
			const response = await fetch(apiUrl, {
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (response.status === 404) {
				throw new Error("There was a problem loading experiences");
			}

			if (!response.ok) {
				const errorText = await response.text();
				console.error("Error response text:", errorText);
				throw new Error("Network response was not ok");
			}
			const contentType = response.headers.get("content-type");
			if (contentType && contentType.includes("application/json")) {
				return response.json();
			} else {
				const errorText = await response.text();
				console.error("Error: Expected JSON but received:", errorText);
				throw new Error("Received non-JSON response");
			}
		} catch (error) {
			console.error("Fetch error:", error);
			throw error;
		}
	},

	async getExchangeRates(
		sourceCurrencies: string[],
		targetCurrencies: string[]
	) {
		const response = await fetch(
			`${process.env.REACT_APP_API_URL}/experiences/exchange-rates`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					sourceCurrencies,
					targetCurrencies,
				}),
			}
		);
		if (!response.ok) {
			throw new Error("Failed to fetch exchange rates");
		}
		return response.json();
	},

	async getBookingQuestions(): Promise<{
		bookingQuestions: BookingQuestion[];
	}> {
		const apiUrl = `${process.env.REACT_APP_API_URL}/experiences/products/booking-questions`;

		try {
			const response = await fetch(apiUrl, {
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error("Error response text:", errorText);
				throw new Error("Network response was not ok");
			}
			const contentType = response.headers.get("content-type");
			if (contentType && contentType.includes("application/json")) {
				return response.json();
			} else {
				const errorText = await response.text();
				console.error("Error: Expected JSON but received:", errorText);
				throw new Error("Received non-JSON response");
			}
		} catch (error) {
			console.error("Fetch error:", error);
			throw error;
		}
	},
};
